<template>
  <div>
    页面没有找到
    <a href="/auth.html#/login">登录页面</a>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  data() {
    return {
      msg: '页面没有找到'
    }
  }
}
</script>

<style lang="scss" scoped></style>
